export * from './avatar.props';
export * from './avatar';
